<template>
    <toolbar-option type="stacked">
        <template v-if="slider" slot="secondary">
            <dropdown
                :value="side"
                :options="sideOptions"
                native
                @input="onSideInput"
            />
        </template>

        <template slot="secondary-2">
            <dropdown
                :value="unit"
                :options="unitOptionsNew"
                native
                @input="onUnitInput"
            />
        </template>

        <template slot="primary">
            <collapse id="padding-slider" v-model="slider">
                <slider
                    :value="sliderIndex"
                    :values="themeObjectValues"
                    @input="onInput"
                />
            </collapse>
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';
import { getClassDefinition } from '@/utils/tailwind-helper';

export default {
    name: 'padding',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Padding',
            tailwindDefinitionProp: 'padding',
            defaultUnit: 'rem',
        };
    },

    computed: {
        unitOptionsNew() {
            const options = this.unitOptions;

            options.unshift({ text: 'None', value: '' });

            return options;
        },
    },

    watch: {
        changedOption({ option }) {
            if (option === 'boxed') this.onConflict('boxed');
        },
    },

    methods: {
        onConflict(type) {
            switch (type) {
                // fired when the .fu-boxed class is added, since it uses padding
                case 'boxed': {
                    const state = this.state || 'all';
                    const allPaddingClass = this.selectedElements[0].flexClassCollection.padding[state].default;

                    let allPaddingValue;

                    if (allPaddingClass) {
                        allPaddingValue = getClassDefinition(allPaddingClass).value;
                    }

                    this.removeFlexClass(['default', 'l', 'r', 'x']);

                    // if an "all sides" padding value was detected, then we need to readd the top and bottom padding values
                    // ... as the boxed width option only needs to override the left and right values
                    if (allPaddingValue) {
                        this.addFlexClass({
                            side: 'y',
                            value: allPaddingValue,
                        });

                        this.onSelectedElement();
                    } else {
                        this.side = '';
                    }

                    break;
                }

                default:
                    this.removeFlexClass();
                    this.side = '';
            }

            this.sliderIndex = this.themeObjectValues.indexOf('0rem');
            this.unit = this.defaultUnit;
        },
    },
};
</script>
